import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-not-found-page',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    <mat-card appearance="outlined">
      <mat-card-title>404: Sidan kunde inte hittas!</mat-card-title>
      <mat-card-content>
        <p>Sidan du försökte nå kunde inte hittas. Klicka på "Gå till startsida".</p>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button class="sx-button sx-button--blue" routerLink="/">Gå till startsida</button>
      </mat-card-actions>
    </mat-card>
  `,
    styles: [
        `
           :host {
             text-align: center;
           }
         `
    ],
    standalone: false
})
export class NotFoundPageComponent {}
